// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__P4W_5","upload":"Small_upload__1hRlZ","imageWrap":"Small_imageWrap__1mUo7","removeBtn":"Small_removeBtn__2aXQt"};